var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('img',{staticClass:"avatar",style:(_vm.widthStyle),attrs:{"alt":"Avatar","src":_vm.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }